import { render, staticRenderFns } from "./SupplierMapping.vue?vue&type=template&id=06a6a274&scoped=true"
import script from "./SupplierMapping.vue?vue&type=script&lang=js"
export * from "./SupplierMapping.vue?vue&type=script&lang=js"
import style0 from "./SupplierMapping.vue?vue&type=style&index=0&id=06a6a274&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a6a274",
  null
  
)

export default component.exports